// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__jyDLp","active":"NavigationItem_active__xJLiQ"};